import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AuthorizeService } from '../../auth/authorize.service';
import { ApplicationPaths } from '../../auth/api-authorization.constants';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { AppProfileService } from '../../services/profile.service';
import { ExtendedProfile } from '../../common/ExtendedProfile';
import { MyAccountNavComponent } from '../my-account-nav/my-account-nav.component';

@Component({
    imports: [CommonModule, RouterModule, FontAwesomeModule, MyAccountNavComponent],
    selector: 'app-login-menu',
    templateUrl: './login-menu.component.html',
    styleUrls: ['./login-menu.component.css']
})
export class LoginMenuComponent implements OnInit {
  private authorizeService = inject(AuthorizeService);
  private appProfileService = inject(AppProfileService);

  private destroyRef = inject(DestroyRef);

  public faUserCircle = faUserCircle;
  public profile: ExtendedProfile = new ExtendedProfile();
  public isAuthenticated$: Observable<boolean>;
  public userName$: Observable<string>;
  ApplicationPaths = ApplicationPaths;

  ngOnInit(): void {
    this.isAuthenticated$ = this.authorizeService.isAuthenticated();
    this.appProfileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((profile) => {
      this.profile = profile;
    });
  }
}
